import { createAction } from '@reduxjs/toolkit';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import type { DemographicIdCode } from '~/store/boundaryGroups/boundaryGroups.repository';
import type {
  DataLayerGroup,
  DataLayerGroupData,
  DataLayerGroupId,
  DataLayerGroupSettings,
  DataLayerIndividualSettings,
} from './mapSettingsDataLayers.state';

export const mapSettingsDataLayersAddDataLayer = createAction(
  'MAP_SETTINGS_DATA_LAYERS_ADD_DATA_LAYER',
  (dataLayer: DataLayerGroup) => ({
    payload: { dataLayer },
  })
);

export const mapSettingsDataLayersRemoveDataLayer = createAction(
  'MAP_SETTINGS_DATA_LAYERS_REMOVE_DATA_LAYER',
  (dataLayer: DataLayerGroup) => ({
    payload: { dataLayer },
  })
);

export const mapSettingsDataLayersUpdateDataLayer = createAction(
  'MAP_SETTINGS_DATA_LAYERS_UPDATE_DATA_LAYER',
  ({ id, data, settings, fromTemplate }: {
    id: DataLayerGroupId;
    data?: DataLayerGroupData;
    settings?: DataLayerGroupSettings;
    fromTemplate?: DataLayerGroup['fromTemplate'];
  }) => ({
    payload: { id, data, settings, fromTemplate },
  })
);

export const mapSettingsDataLayersUpdateBoundaryGroup = createAction(
  'MAP_SETTINGS_DATA_LAYERS_UPDATE_BOUNDARY_GROUP',
  (dataLayerId: DataLayerGroupId, boundaryGroupId: BoundaryGroupId) => ({
    payload: { dataLayerId, boundaryGroupId },
  })
);

export const mapSettingsDataLayersUpdateIndividualLayerSettings = createAction(
  'MAP_SETTINGS_DATA_LAYERS_UPDATE_INDIVIDUAL_LAYER_SETTINGS',
  ({ boundaryGroupId, demographicId, dataLayerId, settings }: {
    boundaryGroupId: BoundaryGroupId;
    demographicId: DemographicIdCode;
    dataLayerId: DataLayerGroupId;
    settings: DataLayerIndividualSettings;
  }) => ({
    payload: {
      boundaryGroupId, demographicId, dataLayerId, settings,
    },
  })
);
